export default __webpack_public_path__ + "static/media/falcon-9-spacex-falcon-9-png-414_5414.d5d57c28.png";